import type { Components } from '@mui/material/styles';

export default function MuiPaper(): Components['MuiPaper'] {
  return {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  };
}
